export const siteInfo = {
  name: '爆料直播网',
  shortName: '爆料直播',
  slogan: '今天播什么，一眼看清',
  description:
    '爆料直播网把全天的直播场次按时间梳理清楚，今日直播排期、即将开始场次、直播回放列表与热门直播推荐集中呈现，还支持直播预告提醒，让你不再错过任何一场。',
  email: 'contact@baoliaolive.com',
  workTime: '每日 09:00 - 23:30（含节假日）',
  updateNote: '排期每 15 分钟自动校对一次，以主播开播通知为准。',
};

export const navLinks = [
  { label: '首页', path: '/' },
  { label: '今日排期', path: '/schedule' },
  { label: '直播回放', path: '/replay' },
  { label: '关于我们', path: '/about' },
];

export const categories = [
  { key: '娱乐爆料', desc: '影视、综艺、名人动向的第一手讨论', icon: 'ri-fire-line' },
  { key: '财经观察', desc: '盘面异动、政策解读与市场复盘', icon: 'ri-line-chart-line' },
  { key: '游戏电竞', desc: '赛事解说、版本分析与冲分实录', icon: 'ri-gamepad-line' },
  { key: '生活好物', desc: '开箱测评、家清收纳与换季清单', icon: 'ri-shopping-bag-3-line' },
  { key: '科技前沿', desc: '新品解读、行业圆桌与技术观察', icon: 'ri-cpu-line' },
  { key: '体育赛事', desc: '赛前连线、焦点战复盘与战术拆解', icon: 'ri-basketball-line' },
  { key: '情感夜话', desc: '深夜陪伴、关系议题与来信回复', icon: 'ri-heart-3-line' },
  { key: '音乐现场', desc: '小型 Live、翻唱专场与幕后花絮', icon: 'ri-music-2-line' },
];